/** @jsx jsx */
import { sizer } from "@trueskin-web/functions"
import { jsx } from "@trueskin-web/theme"
import { questionIcon } from "@trueskin-web/theme/icons/questionIcon"

const sizes = {
  xlg: {
    height: 40,
    width: 40,
  },
  lg: {
    height: 32,
    width: 32,
  },
  md: {
    height: 24,
    width: 24,
  },
  sm: {
    height: 16,
    width: 16,
  },
  xsm: {
    height: 12,
    width: 12,
  },
}

const Icon = ({
  icon,
  asImage = false,
  size = "md",
  color = "currentColor",
  role = "presentation",
  focusable = false,
  ...props
}) => {
  if (typeof icon === "string") {
    if (asImage) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          sx={{
            display: "inline-block",
            verticalAlign: "middle",
            ...sizer(sizes, size),
          }}
          {...props}
        >
          <image
            xlinkHref={icon}
            sx={{
              ...sizer(sizes, size),
            }}
          />
        </svg>
      )
    }

    return (
      <div
        sx={{
          maskImage: `url(${icon})`,
          maskRepeat: "no-repeat",
          maskPosition: "center",
          maskSize: "100%",

          display: "inline-block",
          verticalAlign: "middle",
          backgroundColor: color,
          ...sizer(sizes, size),
        }}
        {...props}
      />
    )
  }

  return (
    <svg
      sx={{
        display: "inline-block",
        verticalAlign: "middle",
        flexShrink: 0,
        backfaceVisibility: "hidden",
        color,
        "&:not(:root)": {
          overflow: "hidden",
        },
        ...sizer(sizes, size),
      }}
      viewBox={icon?.viewBox || "0 0 24 24"}
      focusable={focusable}
      role={role}
      fill={icon?.fill}
      {...props}
    >
      {icon?.path || questionIcon.path}
    </svg>
  )
}

export default Icon
export { sizes }
